<template>
    <video
        :class="cssClass"
        v-if="isVideo && isVideoAllowed"
        :src="videoSources.videoUrl"
        :poster="videoSources.fallbackImageUrl"
        playsinline
        :muted="!videoHasSound"
        :loop="loopVideo && !videoHasSound"
        :autoplay="!videoHasSound"
        :width="width"
        :height="height"
        @loadeddata="emit('mediaLoaded')"
    >
        <source
            :src="videoSources.videoUrl"
            :type="videoSources.videoUrl.includes('.webm') ? 'video/webm' : 'video/mp4'"
        />
    </video>
    <WebpImage
        v-else
        :src="src"
        :cssClass="cssClass"
        :alt="alt"
        :width="width"
        :height="height"
        :isLazyload="isLazyload"
        :loadingPriority="loadingPriority"
        :media="media"
        :get2x="get2x"
        @imageLoaded="emit('mediaLoaded')"
    />
</template>

<script lang="ts" setup>
import { computed } from "vue";
import WebpImage from "../image/webp-image.vue";

const props = withDefaults(
    defineProps<{
        src: string;
        cssClass?: Array<string> | string | Record<string, any>;
        alt: string;
        width?: number | string;
        height?: number | string;
        isLazyload?: boolean;
        loadingPriority?: "high" | "low" | "auto";
        /**
         * Specify a media query for the source
         */
        media?: string;
        /**
         * If true, 2x image will be added
         * url has to be in format: /path/to/image@2x.png (or jpg)
         */
        get2x?: boolean;
        videoHasSound?: boolean;
        loopVideo?: boolean;
        isVideoAllowed?: boolean;
    }>(),
    {
        isLazyload: false,
        get2x: false,
        videoHasSound: false,
        loopVideo: true,
        isVideoAllowed: true,
    }
);

const emit = defineEmits(["mediaLoaded"]);

const videoSources = computed(() => {
    if (!props.src || props.src.trim() === "") {
        return {
            videoUrl: null,
            fallbackImageUrl: "",
        };
    }

    const images = props.src.split("|").filter(Boolean);
    const isVideo = images[0].includes(".webm") || images[0].includes(".mp4");

    const fallbackImageUrl = isVideo ? (images.length > 1 ? images[1] : "") : images[0];
    const videoUrl = isVideo ? images[0] : null;

    return {
        videoUrl,
        fallbackImageUrl,
    };
});

const isVideo = computed(() => props.src.includes(".webm") || props.src.includes(".mp4"));
</script>
